import { action } from 'mobx'

import BaseListStore, { IBaseListAddOptions } from 'stores/base/BaseListStore'

import getModelId from 'utils/getModelId'

import Model, { IModelCreatePayload } from './Model'

class ModelStore extends BaseListStore<Model, IModelCreatePayload> {
  constructor() {
    super(Model)
  }

  @action
  add(
    model: Omit<IModelCreatePayload, 'id'>,
    options: IBaseListAddOptions = {}
  ): Model {
    const modelId = getModelId(model.name)
    const createdModel = super.add(
      {
        ...model,
        id: modelId,
      },
      options
    )

    return createdModel
  }

  getByName = (name: string): Model | null => {
    // Since the model's ID is its name, searching by name can be made fast.
    // DO NOT use the above information outside this class. We do not want to leak implementation details outside.
    return this.get(name)
  }
}

export default new ModelStore()
